'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _smoothScroll = require('smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripHeroProductV1.$inject = ['$window', 'ApiService'];


var _module = angular.module('cb.strips.cbStripHeroProductV1', []);

_module.directive('cbStripHeroProductV1', cbStripHeroProductV1);

exports.default = _module;


function cbStripHeroProductV1($window, ApiService) {
    return {
        restrict: 'A',
        link: cbStripHeroProductV1Link,
        controller: cbStripHeroController,
        controllerAs: 'hero'
    };

    function cbStripHeroProductV1Link(scope, element, attr) {
        addHeroProductCbFunctions(element);

        angular.forEach(element.find('.list--checkmark > li'), function (ubr) {
            addHeroProductUbrCbFunctions(ubr);
        });

        angular.forEach(element.find('.nav-list > li'), function (nav) {
            addHeroProductNavCbFunctions(nav);
        });
    }

    function cbStripHeroController() {
        var vm = this;

        var scroll = new _smoothScroll2.default();

        vm.scrollTo = function (nodeSelector, isMeerInformatie) {
            $window.requestAnimationFrame(function () {
                var node = $(nodeSelector);
                if (node) {
                    scroll.animateScroll(node[0]);
                    if (isMeerInformatie) {
                        cb('meer-informatie', 'open', nodeSelector.substring(1));
                    }
                }
            });
        };
    }

    function addHeroProductCbFunctions(element) {
        var _gettersAndSetters = addHeroProductGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'hero-product': gettersAndSetters
        });
    }

    function addHeroProductUbrCbFunctions(element) {
        var _gettersAndSetters = addHeroProductUbrGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'hero-product-ubr': gettersAndSetters
        });
    }

    function addHeroProductNavCbFunctions(element) {
        var _gettersAndSetters = addHeroProductNavGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        ApiService.attach({
            'hero-product-nav': gettersAndSetters
        });
    }

    function addHeroProductGettersAndSetters(element) {
        var hero = {};

        Object.defineProperty(hero, 'herotitle', {
            get: function get() {
                return element.find('.hero__title').html();
            },
            set: function set(newValue) {
                return element.find('.hero__title').html(newValue);
            }
        });

        Object.defineProperty(hero, 'herosubtitle', {
            get: function get() {
                return element.find('.hero__subtitle').html();
            },
            set: function set(newValue) {
                return element.find('.hero__subtitle').html(newValue);
            }
        });

        Object.defineProperty(hero, 'title', {
            get: function get() {
                return element.find('.heading-page-title').html();
            },
            set: function set(newValue) {
                return element.find('.heading-page-title').html(newValue);
            }
        });

        Object.defineProperty(hero, 'subtitle', {
            get: function get() {
                return angular.element(element.find('.heading-page-subtitle')[0]).html();
            },
            set: function set(newValue) {
                return angular.element(element.find('.heading-page-subtitle')[0]).html(newValue);
            }
        });

        Object.defineProperty(hero, 'navtitle', {
            get: function get() {
                return angular.element(element.find('.heading-page-subtitle')[1]).html();
            },
            set: function set(newValue) {
                return angular.element(element.find('.heading-page-subtitle')[1]).html(newValue);
            }
        });

        Object.defineProperty(hero, 'text', {
            get: function get() {
                return element.find('.strip__text-block').html();
            },
            set: function set(newValue) {
                return element.find('.strip__text-block').html(newValue);
            }
        });

        Object.defineProperty(hero, 'image', {
            get: function get() {
                return $('.hero__image').css('background-image');
            },
            set: function set(newValue) {
                return $('.hero__image').css('background-image', 'url("' + newValue + '")');
            }
        });

        Object.defineProperty(hero, 'imageAlt', {
            get: function get() {
                return $('.hero__image').attr('title');
            },
            set: function set(newValue) {
                $('.hero__image').attr('title', newValue);
            }
        });

        /*
        cb('hero-product','set', {
            'calamiteiten-banner': {
                id:       'storm-A1',
                styling:  'major',
                icon:     'warning',
                title:    'Schaatsen uit het vet?',
                text:     'Op natuurijs schaatsen zit er waarschijnlijk niet in. Maar het gaat de komende dagen wel vriezen. Wat is handig bij bevriezing en gladheid op de weg?',
                cta:      'Lees onze tips',
                link:     'https://www.centraalbeheer.nl/magazine/paginas/magazine.aspx/in-het-verkeer/tips-bevriezing-gladheid'
            }
        });
        */

        Object.defineProperty(hero, 'calamiteiten-banner', {
            get: function get() {
                return element.find('.calamiteiten-banner__wrapper');
            },
            set: function set(newValue) {
                var compile = angular.element(document.body).injector().get('$compile');
                var scope = angular.element(document.body).injector().get('$rootScope');
                var calamiteitenBanner = document.createElement('cb-calamiteiten-banner');

                element[0].getElementsByClassName('hero__container')[0].insertAdjacentElement('afterend', calamiteitenBanner);

                var banner = angular.element('cb-calamiteiten-banner');

                var allowedAttributes = ['id', 'styling', 'icon', 'title', 'text', 'link', 'cta'];
                allowedAttributes.forEach(function (attr) {
                    if (newValue[attr] !== undefined) {
                        banner.attr(attr, newValue[attr]);
                    }
                });

                compile(banner)(scope);
            }
        });

        return hero;
    }

    function addHeroProductUbrGettersAndSetters(element) {
        var ubr = {};

        Object.defineProperty(ubr, 'text', {
            get: function get() {
                return angular.element(element).html();
            },
            set: function set(newValue) {
                return angular.element(element).html(newValue);
            }
        });

        return ubr;
    }

    function addHeroProductNavGettersAndSetters(element) {
        var nav = {};

        Object.defineProperty(nav, 'link', {
            get: function get() {
                return angular.element(element).find('a').text();
            },
            set: function set(newValue) {
                if (newValue.text) {
                    angular.element(element).find('a').text(newValue.text);
                }
                if (newValue.href) {
                    angular.element(element).find('a').attr('href', newValue.href);
                }
                if (newValue.icon) {
                    var icon = angular.element(element).find('.icon');
                    (0, _from2.default)(icon[0].classList).filter(function (className) {
                        return className.search(/icon--(?!(lg))[a-zA-Z]*/gi) === 0;
                    }).forEach(function (className) {
                        icon.removeClass(className);
                    });
                    icon.addClass('icon--' + newValue.icon);
                }
            }
        });

        return nav;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/hero-product-v1/hero-product.directive.js
// module id = 946
// module chunks = 1